import JobOffer from 'builder/components/JobOffer'

const OfferAnalyzerView = () => {
  return <JobOffer />
}

export default OfferAnalyzerView
